import { createContext, useContext, useState, useLayoutEffect, type ReactNode } from "react"

type PageHeaderState = {
  title: string
  back?: string
  backLabel?: string
  extra?: ReactNode
}

type PageHeaderContextType = {
  state: PageHeaderState | null
  setState: (state: PageHeaderState | null) => void
}

const PageHeaderContext = createContext<PageHeaderContextType | null>(null)

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<PageHeaderState | null>(null)
  return <PageHeaderContext.Provider value={{ state, setState }}>{children}</PageHeaderContext.Provider>
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext)
  if (!context) throw new Error("usePageHeader must be used within PageHeaderProvider")
  return context.state
}

export function PageHeader({ title, back, backLabel, extra }: PageHeaderState) {
  const context = useContext(PageHeaderContext)
  if (!context) throw new Error("PageHeader must be used within PageHeaderProvider")

  useLayoutEffect(() => {
    context.setState({ title, back, backLabel, extra })
    return () => context.setState(null)
  }, [title, back, backLabel, extra])

  return null
}
